var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPantry(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 12.5C25 10.9241 24.6896 9.36371 24.0866 7.9078C23.4835 6.45189 22.5996 5.12902 21.4853 4.01472L17.8264 7.67357C18.4602 8.30739 18.963 9.05984 19.306 9.88796C19.6491 10.7161 19.8256 11.6036 19.8256 12.5H25Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4853 4.01472C19.2348 1.76428 16.1826 0.5 13 0.5L13 5.6744C14.8103 5.6744 16.5464 6.39352 17.8264 7.67357L21.4853 4.01472Z",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 12.5C25 15.6826 23.7357 18.7348 21.4853 20.9853L17.8262 17.3262C19.1062 16.0462 19.8253 14.3102 19.8253 12.5H25Z",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4853 20.9853C19.2348 23.2357 16.1826 24.5 13 24.5L13 19.3256C14.8103 19.3256 16.5464 18.6065 17.8264 17.3264L21.4853 20.9853Z",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 24.5C9.8174 24.5 6.76515 23.2357 4.51472 20.9853L8.17357 17.3264C9.45362 18.6065 11.1897 19.3256 13 19.3256L13 24.5Z",
    stroke: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.51472 20.9853C3.40042 19.871 2.5165 18.5481 1.91345 17.0922C1.31039 15.6363 1 14.0759 1 12.5L6.1744 12.5C6.1744 13.3964 6.35095 14.2839 6.69397 15.112C7.03699 15.9402 7.53976 16.6926 8.17357 17.3264L4.51472 20.9853Z",
    stroke: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1 12.5C1 9.3174 2.26428 6.26516 4.51472 4.01472L8.17357 7.67357C6.89352 8.95362 6.1744 10.6897 6.1744 12.5L1 12.5Z",
    stroke: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.51472 4.01472C5.62902 2.90042 6.95189 2.0165 8.4078 1.41345C9.86371 0.810389 11.4241 0.5 13 0.5L13 5.6744C12.1036 5.6744 11.2161 5.85095 10.388 6.19397C9.55984 6.53699 8.80739 7.03976 8.17357 7.67357L4.51472 4.01472Z",
    stroke: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPantry);
export default __webpack_public_path__ + "static/media/pantry.01ab3db6a0fd6808207f0996b8c0bac8.svg";
export { ForwardRef as ReactComponent };